document.addEventListener('DOMContentLoaded', function () {
  var images = document.querySelectorAll('.parallax-slider')
  Array.prototype.forEach.call(images, function (image) {
    image.setAttribute('alt', '')
  })
})
